<template>
  <div class="empty-panel">
    <img :src="emptyImage" />
    <p class="mt-3">
      {{ $i18nPresenter.t('Great! You’re on point!') }}
    </p>
  </div>
</template>

<script>
import emptyImage from '@/assets/images/thumbs-up.svg'
import utils from '@/util'

export default {
  data() {
    return {
      emptyImage,
    }
  },

  created() {
    utils.preloadImage({ url: emptyImage })
  },
}
</script>

<style lang="scss" scoped>
.empty-panel {
  @apply flex flex-col items-center;
}
</style>
